@import "tailwindcss";

@theme {
  --color-ninja-dark: #050507;
  --color-ninja-cyan: #33D5E6;
  --color-ninja-primary: #02B6FF;
  --color-ninja-accent: #0A22EE;
  --color-slate-850: #0a0a12;
  --color-slate-855: #08080f;
  --color-slate-955: #030306;
}

body {
  font-family: 'Inter', system-ui, sans-serif;
  background-color: #050507;
  color: #d1d5db;
}
